/* global Sys, Core */
Sys.ns("Core");

/**
 * The Play Mode Manager controller.
 *
 * @class Core.PlayModeManagerController
 * @extends Core.Controller
 */
Core.PlayModeManagerController = {

    USE_LOGGING: false,

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.PlayModeManagerController.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupEvents: function() {
        var me = this;

        me.on({
            "request:playModeManager.addMode": me.addMode,
            "request:playModeManager.removeMode": me.removeMode
        });
    },

    /**
     * Add the mode if it does not already exist.
     *
     * @private
     * @param {string} mode The name of the mode to add.
     * @returns {void}
     */
    addMode: function(mode) {
        this.model.addMode(mode);

        /* DEBUG_START*/
        if (this.USE_LOGGING) {
            console.info("PlayModeManager :: addMode :: mode: " + mode);
            console.info("PlayModeManager :: complete string: " + this.model.getModeString());
        }

        /* DEBUG_END*/
    },

    /**
     * Remove the mode if it exists.
     *
     * @private
     * @param {string} mode The name of the mode to remove.
     * @returns {void}
     */
    removeMode: function(mode) {
        this.model.removeMode(mode);

        /* DEBUG_START*/
        if (this.USE_LOGGING) {
            console.info("PlayModeManager :: removeMode :: mode: " + mode);
            console.info("PlayModeManager :: complete string: " + this.model.getModeString());
        }

        /* DEBUG_END*/
    }
};

Core.PlayModeManagerController = Sys.extend(Core.Controller, Core.PlayModeManagerController, "Core.PlayModeManagerController");
